import CanvasChartImg from "./CanvasChartImg";
export default CanvasChartImg;